export default __webpack_public_path__ + "static/media/3.6fe55ca6.svg";